import Axios from "../../configs/axios.config";

export const academicReport = (data) =>
  Axios.get(`/reports/academic-report`, data).then(
    (response) => response.data.data
  );

export const staffAttendanceReport = (data) =>
  Axios.get(`/reports/staff-attendance-report`, { params: data }).then(
    (response) => response.data.data
  );

  export const staffAttendanceReportByDate = (data) =>
    Axios.get(`/attendance`, { params: data }).then(
      (response) => response.data
    );

  export const staffAttendanceReportExport = (data) =>
    Axios.get(`/reports/staff-attendance-report`, { params: data }).then(
      (response) => response.data.data
    );

export const studentAttendanceReport = (data) =>
  Axios.get(`/reports/student-attendance-report`, { params: data }).then(
    (response) => response.data.data
  );

  export const studentAttendanceReportExport = (data) =>
    Axios.get(`/reports/student-attendance-report`, { params: data }).then(
      (response) => response.data.data
    );

export const examinationReport = (data) =>
  Axios.get(`/reports/student-examination-report`, { params: data }).then(
    (response) => response.data.data
  );

  export const examinationReportExport = (data) =>
    Axios.get(`/reports/student-examination-report`, { params: data }).then(
      (response) => response.data.data
    );

  export const feeReport = (data) =>
    Axios.get(`/reports/fee-report`, { params: data }).then(
      (response) => response.data.data
    );  

    export const staffPerformanceReport = (data) =>
      Axios.get(`/reports/staff-performance-report`, { params: data }).then(
        (response) => response.data.data
      );    

// export const updateRole = (data, id) =>
//   Axios.put(`/workspaces/permission/role/${id}`, data).then(
//     (response) => response.data.data
//   );
// export const getRoleList = (data) =>
//   Axios.get("/workspaces/permission/role", { params: data }).then(
//     (response) => response.data.data
//   );
// export const getRoleDetail = (id) =>
//   Axios.get(`/workspaces/permission/role/${id}`).then(
//     (response) => response.data.data
//   );
// export const deleteRole = (id) =>
//   Axios.delete(`/workspaces/permission/role/${id}`);
